import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';
import { Route } from 'react-router';
import { defaultMemoize } from 'reselect';
import { BreadcrumbStateInfo, SiteUrlsContext } from '../../../data-catalog-shared';
import { createCatalogBreadcrumb, createCatalogDatabaseBreadcrumb } from './BreadcrumbFactories';
import { BreadcrumbsUpdater } from './BreadcrumbsUpdater';

function createDatabaseBreadcrumbsList(
  databaseId: string,
  databaseName: string,
  urls: SiteUrls,
  urlSuffix: string,
): ReadonlyArray<BreadcrumbStateInfo> {
  return [
    createCatalogBreadcrumb(urls),
    createCatalogDatabaseBreadcrumb(databaseId, databaseName, urls, urlSuffix)
  ];
}

export type DatabaseBreadcrumbsUpdaterProps = {
  readonly databaseId: string;
  readonly databaseName: string | null;
};

export class DatabaseBreadcrumbsUpdater extends React.Component<DatabaseBreadcrumbsUpdaterProps> {

  private readonly memoizedCreateDatabaseBreadcrumbsList = defaultMemoize(createDatabaseBreadcrumbsList);

  public override render() {
    if (this.props.databaseName === null) {
      return null;
    }

    return (
      <SiteUrlsContext.Consumer>
        {urls =>
          <Route>
            {({ location }) => {
              const breadcrumbs = this.memoizedCreateDatabaseBreadcrumbsList(
                this.props.databaseId,
                this.props.databaseName || '',
                urls,
                location.search
              );
              return (
                <BreadcrumbsUpdater breadcrumbs={breadcrumbs} />
              );
            }}
          </Route>
        }
      </SiteUrlsContext.Consumer>
    );
  }

}
